import React, { useEffect, useState, useRef } from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';
import './ReportSection.css';

const ReportSection = () => {
  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  const [visibleStart, setVisibleStart] = useState(0);
  const visibleCount = 3; // Number of reports to display at a time
  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const response = await axios.get('http://localhost:5001/reports');
        setReports(response.data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchReports();
  }, []);

  const scroll = (direction) => {
    if (direction === 'left') {
      setVisibleStart((prev) => (prev > 0 ? prev - 1 : 0));
    } else {
      setVisibleStart((prev) => (prev < reports.length - visibleCount ? prev + 1 : prev));
    }

  };

  return (
    <div className="reports-section">
      <h2>Reports</h2>
      <div className="reports-wrapper">
        <button className="scroll-arrow left-arrow" onClick={() => scroll('left')}>
          &#8249;
        </button>
        <div className="reports-container" ref={scrollRef}>
          {error && <p>Error: {error}</p>}
          {reports.slice(visibleStart, visibleStart + visibleCount).map((report, index) => (
            <div key={index} className="report-card">
              <img src={report.image} alt={report.title} className="report-image" />
              <div className="report-content">
                <h4 className="report-title">{report.title}</h4>
                <p className="report-description">{report.description}</p>
                <Link to={report.link} target="_blank" rel="noopener noreferrer" className="read-more">
                  Read More &raquo;
                </Link>
              </div>
            </div>
          ))}
        </div>
        <button className="scroll-arrow right-arrow" onClick={() => scroll('right')}>
          &#8250;
        </button>
      </div>
      <button className="view-all-button">View All</button>
    </div>
  );
};

export default ReportSection;
